import { buildBase } from "./constants";

const BASE = buildBase("admin");

export const ADMIN_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
    ANALYTICS: `${BASE}/analytics`,
    BULK_CREATE_ADVANCES: `${BASE}/bulk-create-advances`,
    PRODUCT_FEEDBACK: `${BASE}/product-feedback`,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */
  const EXAMPLE_DASHBOARD_ROOT = `${BASE}/example-dashboard`;
  const EXAMPLE_DASHBOARD = {
    ROOT: EXAMPLE_DASHBOARD_ROOT,
    detail: (id: string | number) => `${EXAMPLE_DASHBOARD_ROOT}/${id}`,
    settings: (id: string | number) =>
      `${EXAMPLE_DASHBOARD_ROOT}/${id}/settings`,
    analytics: (id: string | number) =>
      `${EXAMPLE_DASHBOARD_ROOT}/${id}/analytics`,
  };

  const ADMIN_ACTIONS_ROOT = `${BASE}/admin-actions`;
  const ADMIN_ACTIONS = {
    ROOT: ADMIN_ACTIONS_ROOT,
    ABANDONED_CART_STATS: `${ADMIN_ACTIONS_ROOT}/abandoned-cart-stats`,
    CREATE_ADVANCES_LEGACY: `${ADMIN_ACTIONS_ROOT}/create-advances-legacy`,
    CREATE_ADVANCES: `${ADMIN_ACTIONS_ROOT}/create-advances`,
    CUSTOMER_IMPORT: `${ADMIN_ACTIONS_ROOT}/customer-import`,
    GENERATE_BARCODES: `${ADMIN_ACTIONS_ROOT}/generate-barcodes`,
    GENERATE_COMPS: `${ADMIN_ACTIONS_ROOT}/generate-comps`,
    GENERATE_COMPS_MEMBERSHIPS: `${ADMIN_ACTIONS_ROOT}/generate-comps-memberships`,
    GENERATE_GIFT_CARDS: `${ADMIN_ACTIONS_ROOT}/generate-gift-cards`,
    GRANT_QUICKBOOKS_ACCESS: `${ADMIN_ACTIONS_ROOT}/grant-quickbooks-access`,
    IMPORTS: `${ADMIN_ACTIONS_ROOT}/imports`,
    JOB_HISTORY: `${ADMIN_ACTIONS_ROOT}/job-history`,
    RESEND_DAILY_STATS: `${ADMIN_ACTIONS_ROOT}/resend-daily-stats`,
    SETTLE_INVOICES: `${ADMIN_ACTIONS_ROOT}/settle-invoices`,
    SHOWSENSE_PREDICTION: `${ADMIN_ACTIONS_ROOT}/showsense-prediction`,
    TRANSACTION_LOOKUP: `${ADMIN_ACTIONS_ROOT}/transaction-lookup`,
    UPLOAD_CUSTOM_SETTLEMENTS: `${ADMIN_ACTIONS_ROOT}/custom-settlements`,
    UPLOAD_CUSTOM_SETTLEMENTS_LEGACY: `${ADMIN_ACTIONS_ROOT}/custom-settlements-legacy`,
    UPLOAD_EXTERNAL_BARCODES: `${ADMIN_ACTIONS_ROOT}/upload-external-barcodes`,
    PASSWORD_IMPORT: `${ADMIN_ACTIONS_ROOT}/password-import`,
  };

  const ONSALES_ROOT = `${BASE}/onsales`;
  const ONSALES = {
    ROOT: ONSALES_ROOT,
    INVENTORY: `${ONSALES_ROOT}/inventory`,
  };

  return {
    ...basicRoutes,
    EXAMPLE_DASHBOARD,
    ADMIN_ACTIONS,
    ONSALES,
  };
})();
